import React from "react";
import INT from "../images/INT.png";
import SSOLogin from "./SSOLogin";

function LoginForm() {
  return (
    <>
      <div className="logoPan">
        <img src={INT} alt="INT." />
        <h4>VAULT</h4>
      </div>
      <h6>Login your account</h6>
      <div className="gLoginBtn">
        <SSOLogin />
      </div>
    </>
  );
}

export default LoginForm;
